__webpack_require__.p = "/visual-design/infographics/it-IT/transizione-giusta/";